import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import {
	BgLimitRequest,
	BgLimitRequestCreate,
	BgLimitRequestFull,
	BgLimitRequestMeta,
	BgLimitRequestSaveModel,
	BgMessage,
	ChangeSocketBg,
} from 'Pages/ibro'
import { Callback } from 'Src/types/utilTypes'
import { SocketMessageTypes } from 'Modules/Socket'

export type BgLimitRequestState = {
	requestParams: RequestParams
	limitRequestData: ResponseCatalog<BgLimitRequest>
	currentLimitRequest: BgLimitRequestFull | null
	limitRequestMeta?: BgLimitRequestMeta
	bgMessage: BgMessage | null
}

export const bgLimitRequestInitialState: BgLimitRequestState = {
	requestParams: new RequestParams(),
	limitRequestData: new ResponseCatalog<BgLimitRequest>(),
	limitRequestMeta: undefined,
	currentLimitRequest: null,
	bgMessage: null,
}

export namespace BgLimitRequestNs {
	export type GetList = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type GetLimitRequestList = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetLimitRequestList = PayloadAction<ResponseCatalog<BgLimitRequest>>
	export type SetLimitRequestMeta = PayloadAction<BgLimitRequestMeta>
	export type GetLimitRequest = PayloadAction<number>
	export type SetLimitRequest = PayloadAction<{
		data: BgLimitRequestFull
	}>
	export type LimitRequestSendRequest = PayloadAction<{
		data: BgLimitRequestSaveModel
		params: Pick<BgLimitRequestFull, 'external_id' | 'status'>
	}>
	export type SaveLimitRequest = PayloadAction<{
		data: BgLimitRequestSaveModel
	}>
	export type SendCreateLimitRequest = PayloadAction<BgLimitRequestCreate>
	export type UpdateStatus = PayloadAction<{
		id: number
		status: boolean
		request_type: SocketMessageTypes
		errors?: unknown[]
		info?: unknown
		changes?: ChangeSocketBg
	}>
	export type SetBgMessage = PayloadAction<BgMessage>
}

export const bgLimitRequestSlice = createSlice({
	name: 'bgLimitRequest',
	initialState: bgLimitRequestInitialState,
	reducers: {
		setRequestParams: (state, action: BgLimitRequestNs.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.requestParams = new RequestParams()
			state.limitRequestMeta = undefined
			state.limitRequestData = new ResponseCatalog<BgLimitRequest>()
		},
		clearItem: (state) => {
			state.currentLimitRequest = null
			state.bgMessage = null
		},

		updateLimitRequestStatus: (state, action: BgLimitRequestNs.UpdateStatus) => {},

		createLimitRequest: (state, action: BgLimitRequestNs.SendCreateLimitRequest) => {},

		getLimitRequestList: (state, action: BgLimitRequestNs.GetLimitRequestList) => {},
		setLimitRequestList: (state, action: BgLimitRequestNs.SetLimitRequestList) => {
			state.limitRequestData = action.payload
		},
		setLimitRequestMeta: (state, action: BgLimitRequestNs.SetLimitRequestMeta) => {
			state.limitRequestMeta = action.payload
		},

		getLimitRequest: (state, action: BgLimitRequestNs.GetLimitRequest) => {},
		setLimitRequest: (state, action: BgLimitRequestNs.SetLimitRequest) => {
			state.currentLimitRequest = action.payload.data
		},
		limitRequestSendRequest: (state, action: BgLimitRequestNs.LimitRequestSendRequest) => {},
		limitSaveRequest: (state, action: BgLimitRequestNs.SaveLimitRequest) => {},
		setBgMessage: (state, action: BgLimitRequestNs.SetBgMessage) => {
			state.bgMessage = action.payload
		},
		clearBgMessage: (state) => {
			state.bgMessage = null
		},
		updateLimit: (state, action) => {},
	},
})
